import _isPossiblePrototype from "../internals/is-possible-prototype";
var exports = {};
var isPossiblePrototype = _isPossiblePrototype;
var $String = String;
var $TypeError = TypeError;
exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + " as a prototype");
};
export default exports;